import React from 'react';
import { clientContactAccessMatrix, getEffectiveClientContactAccess } from '../../utils/clientContactPermissions';

export default function ContactPermissionBadges({ contact }) {
  const permissions = clientContactAccessMatrix.filter(([key]) => getEffectiveClientContactAccess(contact, key) === 'G');
  return <div className="flex max-w-sm flex-wrap gap-1.5">
    {permissions.length ? permissions.map(([key, label]) => <span key={key} className="rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700">{label}</span>) : <span className="text-xs text-slate-400">Aucune</span>}
  </div>;
}
